import React from "react";
import { useNavigate } from "react-router-dom";
import AuthWidget from "../../auth/components/AuthWidget";

export default function SEC_02_02_RegisterController() {
  const navigate = useNavigate();

  return (
    <main id="main" className="page-main" data-scroll-container>
      <div className="page-main-inner">
        <section className="page-section">
          <div className="page-section__body d-flex justify-content-center pt-5">
            <div style={{ width: "100%", maxWidth: "550px" }}>
              <AuthWidget 
                initialMode="REGISTER" 
                onAuthenticated={() => {
                  navigate("/auth/sign-in", { replace: true });
                }}
              />
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}